import React, { useContext, useEffect, useMemo, useState } from "react";
import { useCall } from "./store";
import CallIcon from "assets/svgs/table_call";
import CallCut from "assets/svgs/call_cut.js";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Col, Row } from "react-bootstrap";
import { getCurrentUserRole, getJsonFromSecureLocalStorage,  medrepExt, voitekkAcess } from "modules/utilities/utility";
import { voitekkUserIdMap } from 'modules/utilities/voitekkUSerIdMap'
import VoitekkIntegration from "./VoitekkIntegration";
import secureLocalStorage from "react-secure-storage";
import { Tooltip } from "antd";
import { getCallProviderComponent } from "./service";
import { ActiveEngagement } from "./ShowEngagement";

function CustomerProfile({ user, medrep, setMessageFloater, customer }) {
  const { call } = useCall();
  const { setToaster } = useToast();
  const [phoneIcon, setPhoneIcon] = useState(<CallIcon />);
  const [chatPhoneIcon, setChatPhoneIcon] = useState(<CallIcon />);
  const [alternatePhoneIcon, setAlternatePhoneIcon] = useState(<CallIcon />);
  const { engagementData } = useContext(ActiveEngagement);
  const engagementId = engagementData ? engagementData._id : null;

  useEffect(() => {
    setMessageFloater(true);
  }, []);

  const callProvider = getJsonFromSecureLocalStorage('call_providers')

  return (
    <div className="text-black fs-1 border border-white">
      <Row className="m-2 border rounded">
        <Col
          style={{ background: "#ddd" }}
          className="p-1 ps-2 rounded-start"
          md={3}
        >
          Gender
        </Col>
        <Col className="rounded-end p-1 ps-2" md={9}>
          {user.gender}
        </Col>
      </Row>
      <Row className="m-2 border rounded">
        <Col
          style={{ background: "#ddd" }}
          className="p-1 ps-2 rounded-start"
          md={3}
        >
          Phone
        </Col>
        <Col className="rounded-end p-1 ps-2 d-flex" md={9}>
          {user.phone_number}
          <Tooltip placement="bottom" title='Exoctel'>
          <span
            className="cursor-pointer mx-2"
            onClick={() => {
              setPhoneIcon(<CallCut />);
              call(
                  customer?.orders?.[0]?.case_id || customer?.id,
                  {},
                  engagementId,
                  user?.phone_number,
                  setToaster
                );
            }}
          >
            {phoneIcon}
          </span>
          </Tooltip>
          {voitekkAcess.includes(getCurrentUserRole()) && (
            <VoitekkIntegration
              phone={customer?.user?.phone_number}
              name={secureLocalStorage
                .getItem("first_name")
                .replace(" ", "")
                .toLowerCase()}
              userId={voitekkUserIdMap[secureLocalStorage.getItem("id")]}
              caseId={customer?.id}
            />
          )}
          {Array.isArray(callProvider) &&
            callProvider.map((provider, index) => (
              <div key={index} className="mx-2">
                {getCallProviderComponent(provider, customer, "phone")}
              </div>
            ))}
        </Col>
      </Row>
      <Row className="m-2 border rounded">
        <Col
          style={{ background: "#ddd" }}
          className="p-1 ps-2 rounded-start"
          md={3}
        >
          Alternate Phone
        </Col>
        <Col className="rounded-end p-1 ps-2" md={9}>
          {user?.alternate_phone ? (
            <div className="d-flex">
              <span
                className="cursor-pointer mx-2"
                onClick={() => {
                  setAlternatePhoneIcon(<CallCut />);
                  medrepExt.includes(getCurrentUserRole())
                    ? call(
                        customer?.orders?.[0]?.case_id || customer?.id,
                        {},
                        engagementId,
                        user?.alternate_phone_hash,
                        setToaster
                      )
                    : call(
                        customer?.orders?.[0]?.case_id || customer?.id,
                        {},
                        engagementId,
                        user?.alternate_phone,
                        setToaster
                      );
                }}
              >
                {user?.alternate_phone}
                {alternatePhoneIcon}
              </span>
              {voitekkAcess.includes(getCurrentUserRole()) && (
                <VoitekkIntegration
                  phone={customer?.user?.phone_number}
                  name={secureLocalStorage
                    .getItem("first_name")
                    .replace(" ", "")
                    .toLowerCase()}
                  userId={voitekkUserIdMap[secureLocalStorage.getItem("id")]}
                  caseId={customer?.id}
                />
              )}
              {Array.isArray(callProvider) &&
                callProvider.map((provider, index) => (
                  <div key={index} className="mx-2">
                    {getCallProviderComponent(
                      provider,
                      customer,
                      "alternatePhone"
                    )}
                  </div>
                ))}
            </div>
          ) : (
            <span>N/A</span>
          )}
        </Col>
      </Row>
      <Row className="m-2 border rounded">
        <Col
          style={{ background: "#ddd" }}
          className="p-1 ps-2 rounded-start"
          md={3}
        >
          Email
        </Col>{" "}
        <Col className="rounded-end p-1 ps-2" md={9}>
          {user?.email}
        </Col>
      </Row>
      {user.latest_sales_rep && (
        <Row className="m-2 border rounded">
          <Col
            style={{ background: "#ddd" }}
            className="p-1 ps-2 rounded-start"
            md={3}
          >
            Sales Rep
          </Col>
          <Col className="rounded-end p-1 ps-2" md={9}>
            {user?.latest_sales_rep?.first_name}
          </Col>
        </Row>
      )}
      {user.chat_phone_number && (
        <Row className="m-2 border rounded">
          <Col
            style={{ background: "#ddd" }}
            className="p-1 ps-2 rounded-start"
            md={3}
          >
            Chat Phone
          </Col>
          <Col className="rounded-end p-1 ps-2 d-flex" md={9}>
            {user.chat_phone_number}
            <span
              className="cursor-pointer mx-2"
              onClick={() => {
                setChatPhoneIcon(<CallCut />);
                medrepExt.includes(getCurrentUserRole())
                  ? call(
                      customer?.orders?.[0]?.case_id || customer?.id,
                      {},
                      engagementId,
                      user?.chat_phone_number_hash,
                      setToaster
                    )
                  : call(
                      customer?.orders?.[0]?.case_id || customer?.id,
                      {},
                      engagementId,
                      user?.chat_phone_number,
                      setToaster
                    );
              }}
            >
              {chatPhoneIcon}
            </span>
            {voitekkAcess.includes(getCurrentUserRole()) && (
              <VoitekkIntegration
                phone={customer?.user?.phone_number}
                name={secureLocalStorage
                  .getItem("first_name")
                  .replace(" ", "")
                  .toLowerCase()}
                userId={voitekkUserIdMap[secureLocalStorage.getItem("id")]}
                caseId={customer?.id}
              />
            )}
            {Array.isArray(callProvider) &&
              callProvider.map((provider, index) => (
                <div key={index} className="mx-2">
                  {getCallProviderComponent(provider, customer, "chat")}
                </div>
              ))}
          </Col>
        </Row>
      )}
      <Row className="m-2 border rounded">
        <Col
          style={{ background: "#ddd" }}
          className="p-1 ps-2 rounded-start"
          md={3}
        >
          Med Rep
        </Col>
        <Col className="rounded-end p-1 ps-2" md={9}>
          {medrep}
        </Col>
      </Row>
    </div>
  );
}

export default CustomerProfile;
